import React from 'react';

import { array } from 'prop-types';

import { getTarget } from '../../../../libs';

import { ListItem, Link, ListStyled } from './styles';

const FooterDepartment = ({ department }) => (
  <ListStyled>
    {department &&
      department.map((elem) => (
        <ListItem key={elem.title}>
          <Link href={elem.link} title={elem.title} target={getTarget(elem.target)}>
            {elem.title}
          </Link>
        </ListItem>
      ))}
  </ListStyled>
);

FooterDepartment.defaultProps = {
  department: [],
};

FooterDepartment.propTypes = {
  department: array,
};

export default FooterDepartment;
